import React, { Component } from 'react';
import Player from 'components/player';

class TeamsTable extends Component {
  render() {
    const { teams, players } = this.props;

    let playersSection;

    playersSection = (
      <tr>
        {teams.map((team) => {
          let filteredPlayers = players
            .filter((player) => player.fnTeamID === team.fnTeamID)
            .sort((a, b) => {
              if (a.captain !== b.captain) {
                return a.captain ? -1 : 1;
              }
              if (!(a.captain && b.captain) && a.assistant !== b.assistant) {
                return a.assistant ? -1 : 1;
              }

              // sorts alphabetically
              // if (a.name.toLowerCase() !== b.name.toLowerCase()) {
              //  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
              //  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
              // }

              // sorts by pick order
              return b.fnPickOrder - a.fnPickOrder;
            });

          return (
            <td
              key={team.fnTeamID}
              className="teams-table--row--team"
              nowrap="true">
              {filteredPlayers.map((player) => (
                <Player key={player.id} {...player} />
              ))}
            </td>
          );
        })}
      </tr>
    );
    return (
      <div className="teams-table">
        <table>
          <thead>
            <tr>
              {teams.map((team) => (
                <th key={team.fnTeamID} className="teams-table--header--team">
                  <div className="teams-table--header--team--image">
                    <img
                      src={team.fcImageURL}
                      alt={team.fcTeamName}
                      width="128"
                      height="128"
                    />
                  </div>
                  <div className="teams-table--header--team--name">
                    {team.fcTeamName}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{playersSection}</tbody>
        </table>
      </div>
    );
  }
}

export default TeamsTable;



// WEBPACK FOOTER //
// ./src/components/teams-table/teams-table.js